import CustomDrawer from "@/components/drawer";
import {
  Blockquote,
  Box,
  Button,
  Card,
  Group,
  Indicator,
  Skeleton,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconCalendar, IconClock, IconPhone } from "@tabler/icons-react";
import moment from "moment-jalaali";

import { CalendarEvent } from "@/components/calendar";
import {
  Actor,
  AppointmentStatus,
  MerchantAppointmentQueueDto,
} from "@/models/club";
import CustomerInfo from "../schedule/appointment/CustomerInfo";
import { useGetAppointmentDepositById } from "@/services/appointment/hooks/useGetAppointmentDepositById";
import AppointmentInfo from "./AppointmentInfo";
import { useNavigate } from "react-router-dom";

type Props = {
  previewEvent: boolean;
  closePreviewEvent: () => void;
  selectedEvent: CalendarEvent;
  selectedDate: moment.Moment;
  currentDate: moment.Moment;
  cancelOpen: () => void;
};

function PreviewEvent({
  previewEvent,
  closePreviewEvent,
  selectedEvent,
  selectedDate,
  currentDate,
  cancelOpen,
}: Props) {
  const color =
    selectedEvent?.status === AppointmentStatus.Value0
      ? "var(--mantine-color-blue-5)"
      : selectedEvent?.status === AppointmentStatus.Value1
        ? selectedEvent.actor === Actor.Value10 &&
          selectedEvent?.rateBreakdown != null
          ? "var(--mantine-color-teal-5)"
          : "var(--mantine-color-blue-5)"
        : selectedEvent?.status === AppointmentStatus.Value2
          ? "var(--mantine-color-red-5)"
          : selectedEvent?.status === AppointmentStatus.Value3
            ? "var(--mantine-color-yellow-5)"
            : selectedEvent?.status === AppointmentStatus.Value4
              ? "var(--mantine-color-yellow-5)"
              : "var(--mantine-color-dark-5)";

  const statusText =
    selectedEvent?.status === AppointmentStatus.Value0
      ? "رزرو شده"
      : selectedEvent?.status === AppointmentStatus.Value1
        ? selectedEvent.actor === Actor.Value10 &&
          selectedEvent?.rateBreakdown != null
          ? "پرداخت شده"
          : "تایید شده"
        : selectedEvent?.status === AppointmentStatus.Value2
          ? "کنسل شده"
          : selectedEvent?.status === AppointmentStatus.Value3
            ? "پرداخت ناموفق"
            : selectedEvent?.status === AppointmentStatus.Value4
              ? "بازگشت داده شده"
              : "نا مشخص";

  const { data: appointmentDeposit, isLoading: isLoadingAppointmentDeposit } =
    useGetAppointmentDepositById({ id: selectedEvent?.id ?? 0 });
  const appointment = appointmentDeposit as MerchantAppointmentQueueDto;
  const navigate = useNavigate();
  return (
    <CustomDrawer
      opened={previewEvent}
      close={closePreviewEvent}
      onClose={closePreviewEvent}
      custom="preview-event"
      position="bottom"
      size="xl"
      styles={{
        close: {
          color: "white",
        },
        header: {
          background: color,
          minHeight: "10px",
          padding: "5px 10px 0px 10px",
        },
        body: {
          padding: 0,
        },
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "95svh",
        }}
      >
        <Box
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Stack
            bg={color}
            //   {
            //   selectedEvent?.status === AppointmentStatus.Value1
            //     ? "var(--mantine-color-teal-5)"
            //     : "var(--mantine-color-blue-5)"
            // }
            p="md"
          >
            <Group justify="space-between" align="center">
              <Title order={6}>
                <Text fw="bold" size="lg" c="white">
                  {moment(selectedDate).format("dddd jD jMMMM")}
                </Text>
              </Title>
              <Button variant="outline" color="white" radius="xl" size="xs">
                <Text size="sm" fw="lighter">
                  {statusText}
                </Text>
              </Button>
            </Group>
          </Stack>
          <Stack px="md" mt="md">
            <CustomerInfo
              selectedCustomer={{
                firstName: selectedEvent?.customerFirstName || "",
                lastName: selectedEvent?.customerLastName || "",
                phoneNumber: selectedEvent?.customerMobileNumber || "",
              }}
            />
            <Card withBorder>
              <Group justify="space-between">
                <Group gap="5">
                  <IconCalendar stroke={1} />
                  <Text size="sm" fw="500">
                    {currentDate.format("dddd jD jMMMM")}
                  </Text>
                </Group>
                <Group gap="5">
                  <IconClock stroke={1} />
                  <Text size="sm" fw="500">
                    {moment(selectedEvent?.endTime, "HH:mm:ss").format("HH:mm")}{" "}
                    -{" "}
                    {moment(selectedEvent?.startTime, "HH:mm:ss").format(
                      "HH:mm",
                    )}
                  </Text>
                </Group>
              </Group>
            </Card>
            {isLoadingAppointmentDeposit ? (
              <Skeleton h="60px" />
            ) : (
              <AppointmentInfo appointment={appointment} />
            )}
            {/* {
              selectedEvent?.status === AppointmentStatus.Value0 && selectedEvent?.actor === Actor.Value20 ? (
                <Card withBorder>
                  <Group justify="space-between">
                    <Group>
                      <Indicator inline processing color="orange" size={10} />
                      <Text size="xs" pr="5"> مبلغ بیعانه پرداخت نشده است   </Text>
                    </Group>
                  </Group>
                </Card>
              ) : null}
            {
              selectedEvent?.status === AppointmentStatus.Value1 && selectedEvent?.actor === Actor.Value20 ? (
                <Card withBorder>
                  <Group justify="space-between">
                    <Group>
                      <Indicator inline processing color="green" size={10} />
                      <Text size="xs" pr="5"> مبلغ بیعانه پرداخت شده است   </Text>
                    </Group>
                  </Group>
                </Card>
              ) : null} */}
            <Stack>
              <Text size="md" fw="500" pt="lg">
                خدمات
              </Text>
              <Blockquote color="blue" bg="white" p="xs">
                <Group justify="space-between">
                  <Stack gap="xs">
                    <Text size="sm" fw="500">
                      {selectedEvent?.merchantServiceTitle}
                    </Text>
                    <Group gap="xs">
                      <Text size="xs" c="dimmed">
                        {moment(selectedEvent?.startTime, "HH:mm:ss").format(
                          "HH:mm",
                        )}
                      </Text>
                      <Text c="dimmed">-</Text>
                      <Text size="xs" c="dimmed">
                        {moment(selectedEvent?.endTime, "HH:mm:ss").format(
                          "HH:mm",
                        )}
                      </Text>
                      <Text c="dimmed">-</Text>
                      <Text size="xs" c="dimmed">
                        {selectedEvent?.merchantUserFirstName}{" "}
                        {selectedEvent?.merchantUserLastName}
                      </Text>
                    </Group>
                  </Stack>
                </Group>
              </Blockquote>
            </Stack>

            <Stack>
              {selectedEvent?.status === 2 ? (
                <Blockquote color="red" bg="white" p="xs">
                  <Group justify="space-between">
                    <Stack gap="xs">
                      <Text size="sm" fw="500" c="red">
                        {selectedEvent?.cancellation?.description}
                      </Text>
                    </Stack>
                  </Group>
                </Blockquote>
              ) : null}
            </Stack>
            {selectedEvent?.actor === Actor?.Value10 &&
            selectedEvent?.rateBreakdown != null ? (
              <Stack>
                <Text size="md" fw="500" pt="lg">
                  مبلغ پرداخت شده
                </Text>
                <Blockquote color="blue" bg="white" p="xs">
                  <Group justify="space-between">
                    <Stack gap="xs">
                      <Text size="sm" fw="500">
                        {selectedEvent?.rateBreakdown?.price} ریال
                      </Text>
                      <Group gap="10">
                        <Indicator inline processing size={7} />
                        <Text size="xs" c="dimmed">
                          رزرو آنلاین
                        </Text>
                      </Group>
                    </Stack>
                  </Group>
                </Blockquote>
              </Stack>
            ) : null}
          </Stack>
        </Box>

        <Card
          styles={{
            root: {
              position: "sticky",
              bottom: 0,
              zIndex: 10,
            },
          }}
          withBorder
          radius={0}
        >
          <Group grow>
            <Button
              size="md"
              component="a"
              href={`tel:${selectedEvent?.customerMobileNumber}`}
            >
              <Group justify="center" align="center" gap="xs">
                <Text size="sm" fw="500">
                  تماس
                </Text>
                <IconPhone stroke={1} />
              </Group>
            </Button>
            {selectedEvent?.status !== 2 ? (
              <Button
                size="md"
                color="red"
                variant="outline"
                component="a"
                onClick={cancelOpen}
              >
                <Group justify="center" align="center" gap="xs">
                  <Text size="sm" fw="500">
                    کنسل نوبت
                  </Text>
                </Group>
              </Button>
            ) : null}
            {selectedEvent?.status !== 2 ? (
              <Button
                size="md"
                onClick={() =>
                  navigate(`/dashboard/payments/add/${selectedEvent?.id}`)
                }
              >
                <Group justify="center" align="center" gap="xs">
                  <Text size="sm" fw="500">
                    پرداخت
                  </Text>
                </Group>
              </Button>
            ) : null}
          </Group>
        </Card>
      </Box>
    </CustomDrawer>
  );
}

export default PreviewEvent;
